<template>
  <div>
    <img src="../../../assets/img/fullScreen.png" class="fullScreen" @click="toFull" alt="">
    <div class="stu-inner-main">
      <topBanner :title="getPageTitle()"></topBanner>
      <div class="oq-flex">
        <div class="left">
          <div class="dtsm-btn" @click="dialogVisible = true">答题说明</div>
        </div>
        <!-- 选项 -->
        <div class="main">
          <div class="cn-title">{{ questionData.description }}</div>
          <div class="en-title">{{ questionData.engDescription }}</div>
          <div class="index-title" v-if="questionData.quizForm === 1">例题</div>
          <div class="index-title" v-if="questionData.quizForm === 0">第<span>{{ questionData.quizNumber }}</span>题</div>
          <div class="options">
            <div class="option" :class="isImg ? 'option-img' : ''" v-for=" (item, i) in options" :key="i" @click="chooseFn(i)">
              <div class="option-item" :class="item.choose ? 'choose' : ''">
                <img :src="item.content" v-if="isImg"/>
                <div v-else>{{ item.content }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 进度条 -->
      <div class="progress" v-if="quizForm === 0">
        <div class="progress-item" :style="{ 'width': item.totalPercent + '%' }" v-for="(item, i) in progressData" :key="i">
          <div class="A index">{{item.flag}}</div>
          <div class="inner" :style="{ 'width': item.percent + '%' }"></div>
          <span>{{item.answerNum}}/{{item.quizNum}}</span>
        </div>
      </div>

      <!-- 倒计时 -->
       <div v-if="quizForm === 0">
        <div class="times" v-if="!clickable">本题倒计时：<span>{{quizTimeStr}}</span></div>
        <div class="times" v-if="clickable">请注意考试剩余时间：<span>{{leftTimeStr}}</span></div>
      </div>

      <!-- 底部按钮 -->
       <!-- 作答题目 -->
      <div class="btns" v-if="quizForm === 0">
        <div class="btn btn1" @click="showAnswerList">答题情况</div>
        <!--  -->
        <!-- <div class="btn btn2" @click="nextFn" v-if="!isLastOne">下一题</div>
        <div class="btn btn2" v-if="isLastOne" @click="submit">交卷</div> -->
        <div class="btn btn2" v-if="clickable" @click="save">保存答案</div>

      </div>
        <!-- 例题按钮 -->
      <!-- <div class="btns" v-if="quizForm === 1">
        <div class="btn btn2" @click="startExam">开始答题</div>
      </div> -->
    </div>

    <!-- 弹窗 -->
    <!-- 答题说明 -->
    <el-dialog :visible.sync="dialogVisible" width="80%">
      <div class="dialog-bg">
        <div class="page-title">{{ lang==='cn' ? '答题说明' : 'Exam Instructions'}}
          <div class="lang">
            <div :class="lang === 'cn' ? 'choose' : ''" @click="lang= 'cn'">CN</div>
            <div :class="lang === 'en' ? 'choose' : ''" @click="lang= 'en'">EN</div>
          </div>
        </div>
        <div class="desc" v-if="lang==='cn'">{{ desc }}</div>
        <div class="desc" v-if="lang==='en'">{{ descEn }}</div>
      </div>
    </el-dialog>

    <!-- 答题卡 -->
    <el-dialog :visible.sync="dialogVisible2" width="80%">
      <div class="dialog-bg">
        <div class="page-title page-title1">答题情况</div>
        <div class="clickable-tip" v-if="clickable">- 点击题号查看题目详情 -</div>
          <div class="flag">
            <div class="flag-item" :class="'flag-item'+item.status" v-for="(item,i) in list" :key="i">
              <div class="flag-blank"></div>
              <div>
                <div class="flag-title">{{item.title}}</div>
              </div>
            </div>
          </div>
          <div class="van-popup-content">
            <div class="part" v-for="(item, i) in questionList" :key="i">
              <div class="part-title">{{item.quizTypeStr}}
                共<span>{{item.quizNum}}</span>题
                <span v-if="item.noAnswerNum">（<span>{{item.noAnswerNum}}</span>题尚未完成）</span>
              </div>
              <div class="part-ques">
                <div @click="quizNumberTap(ques)"
                  v-for="(ques,n) in item.answerResults"
                  :key="n"
                  class="question-blank" :class="'question-status' + ques.isAnswer">
                  {{ques.quizNumber}}
                </div>
              </div>
            </div>
          </div>
          <div class="pop-footer">
            <div class="countdown" v-if="clickable">请注意考试剩余时间：<span class="time">{{leftTimeStr}}</span></div>
            <div class="countdown" v-if="!clickable && quizForm === 0">本题倒计时：<span class="time">{{quizTimeStr}}</span></div>
            <div v-if="clickable" class="pop-footer-btn pop-footer-btn-submit" @click="checkPaper">交卷</div>
            <div v-else class="pop-footer-btn" @click="onClose">返回答题</div>
          </div>
      </div>
    </el-dialog>

    <!-- 确认弹窗 -->
     <customConfirm v-if="showConfirm"
      :msg="msg"
      :enMsg="enMsg"
      :confirm="okText"
      :enConfirm="okEnText"
      :cancel="cancelText"
      :enCancel="cancelEnText"
      :isPhone="isPhone"
      @cancel="cancelFn()"
      @confirm="confirmFn()"></customConfirm>
  </div>
</template>
<script>
import env from '@/http/env'
import topBanner from './topBanner.vue'
export default {
  components: {
    topBanner
  },
  data () {
    return {
      activityType: this.$chnEngStatusCode.activityType,
      season: this.$route.query.season,
      raceSchedule: this.$route.query.rs,
      dialogVisible: false,
      dialogVisible2: false,
      desc: '',
      descEn: '',
      quizId: '',
      currentIndex: 0, // 记录当前正在作答的题目（getProgress接口返回的index）
      saveIndex: 0, // 记录保存的哪道题
      pageNum: 0,
      pageSize: 1,
      questionData: {},
      quizMode: 1, // 1单选 >1多选
      options: [], // 选项
      isImg: false, // 选项是否是图片
      correctAnswerList: [], // 正确答案
      quizForm: 0, // 0作答题目 1例题
      total: 0, // 题目总数量
      progressData: [],
      questionList: [], // 答题卡
      list: [
        { status: 0, title: '未完成', enTitle: 'Unanswered' },
        { status: 1, title: '已完成', enTitle: 'Answered' }
      ],
      showConfirm: false,
      msg: '',
      enMsg: '',
      lang: 'cn',
      clickable: false,
      formTimeStr: '',
      isLastOne: false, // 答到最后一题
      pageState: -1, // 记录页面状态，1超时交卷 2主动交卷有未完成题目 3点击例题开始答题
      okText: '',
      okEnText: '',
      cancelText: '',
      cancelEnText: '',
      quizTime: 0, // 每题时间 s，不从试卷设置里取，取接口formMatch/getProgress返回的endTime-now
      quizTimeStr: '', // 每题时间 00:59
      timer: null, // 每题倒计时计时器
      leftTime: 0, // 2分钟倒计时
      leftTimeStr: '',
      timer2: null,
      start2Minutes: false,
      base: env.baseWebIP,
      phone: false,
      quizTimer: null // 请求接口定时器
    }
  },
  created () {
    this.isPhone = window.screen.width < 500
    this.pageNum = 0
    this.saveIndex = 0
    this.queryTheOnlineQuizForm()
  },
  beforeDestroy () {
    this.stopCountdown() // 每题倒计时
    this.stopCountdown2() // 2min倒计时
    this.stopTimer() // 轮询定时器
  },
  methods: {
    /**
     * 复赛答题说明：
     * 1、无主动提交按钮，每题时长获取后端返回的截止提交日期进行倒计时，每题倒计时结束后，自动提交。
     * 2、答题过程中，不可点击答题卡跳题
     * 3、答完全部题目后，倒计时120s（2分钟），倒计时结束后不提交，考生可主动提交，最后需统一点击erp的比赛结束提交试卷
     * 4、最后提交时，如有剩余时间，检查是否有未作答，如果有，弹窗提示
     */
    getPageTitle () {
      return this.$route.query.formName
    },

    // 获取试卷信息
    queryTheOnlineQuizForm () {
      this.$http.get(`${this.base}formMatch/queryTheOnlineQuizForm?season=${this.season}&raceSchedule=${this.raceSchedule}&activityType=${this.activityType}`).then(res => {
        if (res.code === 200) {
          this.desc = res.data.formExplain
          this.descEn = res.data.questionExplain
          this.quizId = res.data.id
          // this.quizTime = Math.floor((res.data.formTime - 120) / 25) // 向上取整
          // this.getQusetionData()

          // 开始轮询题号
          this.queryMatchStatus()
          this.quizTimer = setInterval(() => {
            this.queryMatchStatus()
          }, 1000)
        }
      })
    },

    // 两题间过渡提示
    transitionTips () {
      this.msg = '本题已作答完成，请等待。'
      this.enMsg = 'Answer submitted. Please wait.'
      this.okText = ''
      this.okEnText = ''
      this.cancelText = ''
      this.cancelEnText = ''
      this.showConfirm = true
    },

    /**
     * 轮询
     * 1、返回的参数index是this.pageNum，判断index !== this.pageNum,进入下一题
     * 2、返回的endTime是截止提交时间，用endTime - now开始倒计时，倒计时结束后，提交答案，显示已提交弹窗
     * 3、如果倒计时未结束，裁判点击进入了下一题，要提交本题答案，每次进入下一题需判断答案是否提交
     */

    queryMatchStatus () {
      this.$http.get(this.base + 'formMatch/getProgress', { showLoading: false }).then(res => {
        if (res.code === 200) {
          if (res.data) {
            if (res.data.matchEndType === 2) {
              // 结束
              this.saveAnswer(4)
              // this.savePaper()
            } else if (res.data.questionId) {
              if (!this.clickable) {
                this.endTime = res.data.endTime
                this.currentIndex = res.data.index
                // 进入下一题
                if (Number(res.data.index) !== Number(this.pageNum)) {
                  if (this.saveIndex !== this.pageNum) { // 判断当前题目是否保存。
                    this.saveIndex = this.pageNum
                    this.nextFn()
                  }
                  this.pageNum = res.data.index
                  this.getQusetionData()
                }
              }
            }
          }
        }
      })
    },
    stopTimer () {
      clearInterval(this.quizTimer)
      this.quizTimer = null
    },

    // 获取题目信息
    getQusetionData () {
      this.$http.get(this.base + 'formMatch/queryTheOnlineQuizFormListPage', {
        showLoading: false,
        params: {
          season: this.season,
          raceSchedule: this.raceSchedule,
          activityType: this.activityType,
          quizId: this.quizId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(res => {
        if (res.code === 200) {
          this.total = res.data.total
          this.isLastOne = this.pageNum === this.total
          this.questionData = res.data.list[0]
          this.quizForm = Number(this.questionData.quizForm)
          this.options = this.questionData.choice.split(',').map(item => {
            return { choose: false, content: item }
          })
          this.isImg = this.questionData.choice.includes('http')
          this.correctAnswerList = this.questionData.answer.split(',')
          this.showConfirm = false
          if (this.quizForm === 1) {
            // 例题默认选中
            this.options.forEach(item => {
              this.correctAnswerList.forEach(ans => {
                if (item.content === ans) {
                  item.choose = true
                }
              })
            })
          } else {
            this.queryTheProgressBar()
            this.queryFormAnswer(res.data.list[0])

            this.quizTime = Math.floor((this.endTime - new Date().getTime()) / 1000)
            if (this.quizTime > 0) {
              this.quizTimeStr = this.$xcUtils.sec2time(this.quizTime)
              this.startCountDown()
            } else {
              if (this.isLastOne) {
                this.clickable = true
                const leftTime = Math.floor((this.endTime + 2 * 60 * 1000 - new Date().getTime()) / 1000)
                this.start2Minutes = true
                if (leftTime > 0) {
                  this.startCountDown2(leftTime)
                } else {
                  this.leftTimeStr = '00:00'
                }
              } else {
                this.quizTimeStr = '00:00'
                this.transitionTips()
              }
            }
          }
        }
      })
    },
    // 获取进度条
    queryTheProgressBar () {
      this.$http.post(this.base + 'formMatch/queryTheProgressBar', {
        quizId: this.quizId,
        season: this.season,
        activityType: this.activityType,
        raceSchedule: this.raceSchedule
      }, { showLoading: false }).then(res => {
        if (res.code === 200) {
          const list = res.data
          const flags = ['A', 'B', 'C', 'D', 'E']
          list.forEach((item, index) => {
            item.totalPercent = (item.quizNum / this.total) * 100 // 题型宽度占比
            item.percent = (item.answerNum / item.quizNum) * 100 // 答题进度
            item.flag = flags[index]
          })
          this.progressData = list
          console.log(list)
        }
      })
    },
    // 查询此题目是否做过，做过的回显答案
    queryFormAnswer (question) {
      if (!question.quizNumber) return // 例题不请求
      const data = {
        season: this.season,
        raceSchedule: this.raceSchedule,
        activityType: this.activityType,
        quizId: this.quizId,
        formQuizId: question.formQuizId || question.id,
        quizNumber: question.quizNumber,
        quizSequence: question.quizSequence
      }
      this.$http.post(this.base + 'formMatch/queryTheOnlineFormAnswer', data, { showLoading: false }).then(res => {
        if (res.code === 200) {
          const questionData = res.data.list[0]
          const optionArr = questionData.choice.split(',').map(opt => {
            return {
              content: opt,
              choose: false
            }
          })
          this.quizMode = questionData.answer.split(',').length
          if (questionData.userAnswer) {
            const userAnswerArr = questionData.userAnswer.split(',')
            optionArr.forEach(opt => {
              userAnswerArr.forEach(ans => {
                if (ans === opt.content) {
                  opt.choose = true
                }
              })
            })
          }
          this.$set(this, 'options', optionArr)
          if (this.clickable) {
            this.dialogVisible2 = false
            this.isImg = questionData.choice.includes('http')
            this.questionData = questionData
          }
          this.pageNum = res.data.pageNum
        }
      })
    },
    // 开始倒计时
    startCountDown () {
      this.stopCountdown()
      // console.log('倒计时开始')
      let quizTime = this.quizTime
      this.timer = setInterval(() => {
        quizTime--
        if (quizTime > 0) {
          this.quizTimeStr = this.$xcUtils.sec2time(quizTime)
        } else {
          this.saveIndex = this.pageNum
          this.quizTimeStr = '00:00'
          this.stopCountdown()
          // 超时 不提交
          if (this.isLastOne) {
            this.submit()
          } else {
            this.nextFn()
          }
        }
        // console.log(quizTime, this.quizTimeStr)
      }, 1000)
    },
    // 停止倒计时
    stopCountdown () {
      clearInterval(this.timer)
      this.timer = null
    },
    // 答题结束后，2分钟倒计时
    startCountDown2 (leftTime) {
      this.stopCountdown2()
      console.log('倒计时开始')
      this.timer2 = setInterval(() => {
        leftTime--
        if (leftTime > 0) {
          this.leftTimeStr = this.$xcUtils.sec2time(leftTime)
        } else {
          this.leftTimeStr = '00:00'
          this.stopCountdown2()
          // 时间到，主动交卷 ==》改为不主动交卷
          // this.savePaper()
        }
      }, 1000)
    },
    stopCountdown2 () {
      clearInterval(this.timer2)
      this.timer2 = null
    },

    chooseFn (index) {
      if (this.quizForm === 1) return
      console.log(this.questionData)
      // quizMode 1 单选 >1多选
      console.log(this.quizMode)
      if (this.quizMode === 1) {
        this.options.forEach(item => {
          item.choose = false
        })
        this.options[index].choose = true
      } else {
        this.options[index].choose = !this.options[index].choose
      }
      console.log(this.questionData)
    },
    // 点击例题开始答题
    startExam () {
      console.log(this.pageNum)
      if (this.pageNum === 1) {
        this.msg = '请在裁判席给出明确指令后，再点击“确认”开始答题倒计时。'
        this.enMsg = 'Please wait for the judges to give clearinstructions before clicking “Confrm” to start the countdown timer.'
        this.okText = '确认'
        this.okEnText = 'Confirm'
        this.cancelText = '取消'
        this.cancelEnText = 'Cancel'
        this.showConfirm = true
        this.pageState = 3
      } else {
        this.nextQuestion()
      }
    },
    nextQuestion () {
      // this.pageNum = this.pageNum + 1
      this.getQusetionData()
    },
    confirmFn () {
      if (this.pageState === 3) {
        this.getNextPageInfo()
      } else if (this.pageState === 2) {
        this.savePaper()
      }
    },
    cancelFn () {
      this.showConfirm = false
      if (this.pageState === 2) {
        this.showAnswerList()
      }
    },
    getNextPageInfo () {
      this.showConfirm = false
      // 获取正式题目信息: 题目、进度条、
      this.nextQuestion()
      this.queryTheProgressBar()
    },
    nextFn () {
      this.saveAnswer(1)
    },
    submit () {
      this.saveAnswer(2)
    },
    save () {
      this.saveAnswer(3)
    },
    /**
     * 保存本题答案
     * @param type 1点下一题 2点交卷 3点保存 4裁判系统点本场比赛结束
     */
    saveAnswer (type) {
      const userAnswer = this.options.filter(item => item.choose).map(item => item.content).join(',')
      console.log(userAnswer)
      const data = {
        activityType: this.activityType,
        raceSchedule: this.raceSchedule,
        season: this.season,
        quizId: this.quizId,
        quizInfoId: this.questionData.id,
        userAnswer
      }
      this.$http.post(this.base + 'formMatch/saveTheOnlineFormAnswer', data).then(res => {
        if (res.code === 200) {
          if (type === 1) {
            // 每题之间只保存答案并弹窗本题已答完，不切换下一题
            if (this.quizTimeStr === '00:00') { // 倒计时耗尽展示过渡弹窗，倒计时未耗尽裁判强制提交，不展示过渡弹窗直接进入下一题
              this.transitionTips()
            }
            // this.nextQuestion()
            this.queryTheProgressBar()
          } else if (type === 2) {
            // 超时交卷直接提交（==改为超时不强制交卷，裁判点提交）
            // if (this.pageState === 1) {
            //   // this.savePaper()
            // } else {
            //   // 获取进度条
            //   this.queryTheProgressBar()
            //   // 主动交卷，查询是否有未完成的题目
            //   this.checkPaper(1)
            // }
            // 获取进度条
            this.queryTheProgressBar()
            // 主动交卷，查询是否有未完成的题目
            this.checkPaper(1)
          } else if (type === 3) {
            this.$message.success('已保存')
            // 答题卡查看题目，只保存答案
            this.queryTheProgressBar()
          } else if (type === 4) {
            this.queryTheProgressBar()
            setTimeout(() => {
              this.savePaper()
            }, 500)
          }
          console.log(this.currentIndex, this.isLastOne, this.saveIndex)
          if (this.isLastOne && this.saveIndex === this.currentIndex) {
            this.clickable = true
          }
        }
      })
    },
    // 检查是否有未完成试题
    // type 1-点击试卷右下角的交卷（弹出答题卡确认） else答题卡上的交卷（全部作答的直接交卷）
    checkPaper (type) {
      this.$http.get(this.base + 'formMatch/queryWhetherUnfinishedQuestions', {
        params: {
          activityType: this.activityType,
          raceSchedule: this.raceSchedule,
          season: this.season,
          quizId: this.quizId
        }
      }).then(res => {
        if (res.code === 200) {
          if (!this.start2Minutes) {
            // 开始120s倒计时
            this.start2Minutes = true
            this.leftTimeStr = this.$xcUtils.sec2time(120)
            this.startCountDown2(120)
          }
          // 已完成全部作答1
          // 有未完成作答题目2
          if (res.data === 2) {
            // 有：弹窗提示
            this.pageState = 2
            this.msg = '还有题目尚未完成。'
            this.enMsg = 'Unfinished.'
            this.okText = '交卷'
            this.okEnText = 'Submit'
            this.cancelText = '返回答题'
            this.cancelEnText = 'Back'
            this.showConfirm = true
          } else {
            // 无：弹出答题卡，答题卡按钮显示为【交卷】
            if (type === 1) {
              this.showAnswerList()
            } else {
              this.savePaper()
            }
          }
        }
      })
    },
    savePaper () {
      const data = {
        activityType: this.activityType,
        raceSchedule: this.raceSchedule,
        season: this.season,
        quizId: this.quizId
      }
      this.$http.post(this.base + 'formMatch/saveQuizMatchAnswer', data).then(res => {
        if (res.code === 200) {
          if (this.pageState === 1) {
            // 超时交卷提示
            this.msg = '考试结束，试卷已提交。'
            this.enMsg = 'The exam is over and the answers have been submitted..'
            this.okText = '确定'
            this.okEnText = 'OK'
            this.cancelText = ''
            this.showConfirm = true
          } else {
            // 主动交卷直接弹出完成
            this.$router.push(`/padSemiResult?formName=${this.$route.query.formName}`)
          }
          this.stopCountdown2()
        }
      })
    },
    // 查看答题卡
    showAnswerList () {
      if (this.clickable) {
        this.save()
      }
      this.$http.post(this.base + 'formMatch/queryQuizMatchAnswer', {
        quizId: this.quizId,
        season: this.season,
        activityType: this.activityType,
        raceSchedule: this.raceSchedule
      }).then(res => {
        if (res.code === 200) {
          this.dialogVisible2 = true
          this.questionList = res.data
        }
      })
    },
    // 点击答题卡题号跳转
    quizNumberTap (question) {
      if (this.clickable) {
        this.queryFormAnswer(question)
      }
    },
    onClose () {
      this.dialogVisible2 = false
    },
    toFull () {
      this.$xcUtils.toFull()
    }
    // handleToIndex () {
    //   this.$router.push('/stu/index')
    // }
  }
}
</script>
<style scoped lang="less">
.oq-flex{
  // display: flex;
  width: 90%;
  margin: 20px auto 0;
  .left{
    text-align: center;
    margin-right: 30px;
    .dtsm-btn{
      color: #fff;
      height: 20px;
      line-height: 20px;
      background-color: #f9bd1a;
      border-radius: 20px;
      text-align: center;
      width: 80px;
      cursor: pointer;
      margin-bottom: 10px;
      font-size: 12px;
    }
    .play{
      width: 40px;
    }
  }
}
.main{
  margin-top: 20px;
}
.cn-title{
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
}
.en-title, .desc-t{
  color: #000;
  font-size: 12px;
  margin-bottom: 4px;
}
.index-title{
  color: #000;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  span{
    font-size: 18px;
    font-weight: bold;
    margin: 0 4px;
    color: #B81c25;
  }
}
.options{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  .option{
    height: 42px;
    line-height: 42px;
    background-color: #fff;
    color: #000;
    border-radius: 42px;
    text-align: center;
    width: 140px;
    cursor: pointer;
    box-shadow: 0px 4px 10px 4px rgba(0, 0, 0, .05);
    margin: 10px;
    font-size: 20px;
    font-weight: bold;
     .choose{
      color: #fff;
      background-color: #f9bd1a;
      width: 100%;
      height: 100%;
      border-radius: 42px;
    }
    &.option-img{
      height: 58px;
      line-height: 58px;
    }
    img{
      height: 50px;
      width: auto;
    }
    .option-item{
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.times{
  text-align: center;
  font-size: 16px;
  color: #000;
  font-weight: bold;
  margin-top: 40px;
  span{
    color: #b81c25;
  }
}
.btns{
  display: flex;
  align-items: center;
  justify-content: center;
  .btn{
    margin: 40px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    border-radius: 40px;
    cursor: pointer;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.5);
    }
    &.btn1{
      background-color: #352b28;
    }
    &.btn2{
      background-color: #B81c25;
    }
  }
}
.progress{
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  margin: 40px auto 0;
  .progress-item{
    height: 18px;
    line-height: 18px;
    border: 1px solid #f9bd1a;
    position: relative;
    border-radius: 10px;
    margin: 4px;
    text-align: center;
    color: #ca6903;
    font-size: 12px;
    background-color: rgba(255, 255, 255, .3);
    .index{
      color: #ca6903;
      position: absolute;
      left: 4px;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 10;
      width: 16px;
      font-size: 12px;
      text-align: center;
      line-height: 18px;
    }
    .inner{
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      background: #f9bd1b;
      border-radius: inherit;
    }
    span{
      position: relative;
      z-index: 100;
    }
  }
}
.page-title{
  font-size: 24px;
  font-family: regular;
  text-align: center;
  color: #000;
  margin-top: 10px;
  margin-bottom: 60px;
  position: relative;
  &::after{
    display: block;
    content: '';
    width: 100px;
    height: 2px;
    background-color: #b81c25;
    margin: 4px auto 20px;
  }
  .lang{
    position: absolute;
    right: 40px;
    top: 40px;
    display: flex;
    align-items: center;
    div{
      width: 50px;
      height: 20px;
      margin: 0 4px;
      border-radius: 20px;
      background-color: #000;
      color: #fff;
      text-align: center;
      line-height: 20px;
      font-size: 14px;
      font-family: normal;
    }
    .choose{
      background-color: #B81c25;
    }
  }
}
.page-title1{
  margin-bottom: 0;
}
.desc{
  font-size: 14px;
  color: #000;
  line-height: 28px;
  white-space: pre-line;
  padding-bottom: 40px;
  padding-left: 60px;
  padding-right: 60px;
  min-height: 200px;
}
.dialog-bg{
  background-image: url(../../../assets/img/stu-page-bg.png);
  background-size: 100% auto;
  background-position: left bottom;
  background-repeat: no-repeat;
  .desc{
    background-color: rgba(255,255,255,0.5);
  }
}
/deep/ .el-dialog__body{
  padding: 0;
}

// 答题卡样式
.clickable-tip{
  padding: 12px;
  text-align: center;
  font-family: regular;
  font-size: 18px;
  color: #221714;
}
.flag{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .flag-item{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 18px;
  }
  .flag-blank{
    width: 30px;
    height: 30px;
    border-radius: 6px;
    margin-right: 8px;
    border: 1px solid;
    border-bottom-width: 4px;
  }
  .flag-item0 .flag-blank{
    border-color: #221714;
    border-bottom-color: #221714;
    background-color: #dfdfdf;
  }
  .flag-item2 .flag-blank{
    border-color:#ec525b;
    border-bottom-color: #b81c25;
    background-color: #ec525b;
  }
  .flag-item1 .flag-blank{
      border-color: #f8bc1c;
      border-bottom-color: #b8701d;
    background-color: #f8bc1c;
  }
  .flag-title{
    font-family: regular;
    font-size: 18px;
    line-height: 26px;
  }
  .flag-title-en{
    font-family: regular;
    font-size: 14px;
    color: #A48C4E;
  }
  .van-popup-content{
    overflow-y: auto;
  }
  .part{
    padding-top: 20px;
  }
  .part-title{
    font-size: 18px;
    font-family: regular;
    color: #000;
    font-weight: 500;
    padding: 0 30px;
    display: flex;
    align-items: center;
  }
  .part-title::before{
      content: "";
      display: inline-block;
      width: 3px;
      height: 20px;
      margin-right: 10px;
      background-color: #ecae32;
  }
  .part-title span{
    color: #BB1C25;
  }
  .ques-btn{
    width: 96px;
    height: 96px;
    text-align: center;
    line-height: 96px;
    border-radius: 30px;
    background-color: #e7e6e4;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    margin: 14px;
    float: left;
  }
  .part-ques{
    overflow: hidden;
    padding: 10px 36px;
  }
  .ques-btn1{
    background-color: #f15151;
  }
  .ques-btn2{
    background-color: #f8aa00;
  }
  .question-blank{
    width: 40px;
    height: 40px;
    border-radius: 6px;
    text-align: center;
    line-height: 40px;
    font-size: 24px;
    font-family: hzgb;
    color: #fff;
    margin: 4px;
    float: left;
    border: 1px solid;
    border-bottom-width: 3px;
  }
  .questions{
    overflow: hidden;
  }
  .question-status0{
      border-color: #221714;
      border-bottom-color: #221714;
      background-color: #dfdfdf;
      color: #221714;
  }
  .question-status2{
      border-color:#ec525b;
      border-bottom-color: #b81c25;
      background-color: #ec525b;
  }
  .question-status1{
      border-color: #f8bc1c;
      border-bottom-color: #b8701d;
      background-color: #f8bc1c;
  }
  ::v-deep .el-dialog__header{
    padding: 16px 0 0;
  }
  ::v-deep .el-dialog__headerbtn{
    z-index: 100;
  }
  .countdown{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    .time{
      color: #B81c25;
      font-weight: bold;
      font-size: 18px;
    }
  }
  .pop-footer{
    padding-top: 20px;
    padding-bottom: 40px;
  }
  .pop-footer-btn{
    background-color: #B81c25;
    margin: 10px auto 0;
    border-radius: 42px;
    font-size: 16px;
    color: #fff;
    height: 42px;
    line-height: 42px;
    text-align: center;
    width: 240px;
    &:active{
      box-shadow: inset 0 0 10px rgba(255, 255, 255, 0.5);
    }
  }
  .stu-inner-main{
    width: 100%;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: #d8d8d8;
    background-image: url(../../../assets/img/stu-page-bg.png);
    background-size: 100% auto;
    background-position: left bottom;
    background-repeat: no-repeat;
  }
  .top-banner{
    width: 100%;
    height: 150px;
    background-image: url(../../../assets/img/top-bg.png);
    background-size: cover;
    background-position: center;
    text-align: center;
    line-height: 150px;
    font-size: 30px;
    font-family: regular;
    color: #fff;
    margin-bottom: 20px;
  }
  .fullScreen{
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 30px;
    height: 30px;
  }
  *{
    -webkit-tap-highlight-color: transparent;
  }

@media screen and (max-width: 500px) {
  /* 在这里应用适合小屏幕设备的样式 */
  .options{
    overflow: hidden;
    display: block;
  }
  .options .option{
    float: left;
    width: 40%;
  }
}
</style>
